import React from 'react'
import { ConsentPage } from './ConsentPage'

export const SblConsent = () => (
  <ConsentPage serviceName="SBL" servicePath="sbl_service" />
)
